import { STATUS, INQ_STATUS, PRIORITY, QUOTE_STATUS, DOC_STATUS } from "@/lib/format";
import { cn } from "@/lib/utils";

/* Status is always a dot plus a label. Tones are semantic classes (index.css) that render in both Drift themes. */
const ORDER_CLS = {
  ny: "tone-neutral",
  planlagt: "tone-info",
  paagaar: "tone-active",
  ferdig: "tone-ok",
  fakturert: "tone-done",
};
const INQ_CLS = {
  ny: "tone-active",
  under_behandling: "tone-info",
  konvertert: "tone-ok",
  avvist: "tone-quiet",
};
const PRIO_CLS = {
  lav: "tone-quiet",
  normal: "tone-neutral",
  hoeg: "tone-warn",
  akutt: "tone-danger",
};
const QUOTE_CLS = {
  utkast: "tone-neutral",
  sendt: "tone-info",
  vunne: "tone-ok",
  tapt: "tone-quiet",
};
const DOC_CLS = {
  komplett: "tone-ok",
  manglar: "tone-danger",
  boer_sjekkast: "tone-warn",
};

export const Pill = ({ className, children, testid, dot = true, size = "md" }) => (
  <span
    data-testid={testid}
    className={cn(
      "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full font-medium ring-1 ring-inset",
      size === "sm" ? "h-5 px-2 text-[11.5px]" : "h-6 px-2.5 text-[12.5px]",
      className
    )}
  >
    {dot && <span className="tone-dot h-1.5 w-1.5 shrink-0 rounded-full" aria-hidden />}
    {children}
  </span>
);

export const OrderStatus = ({ status, className, size }) => <Pill size={size} testid={`status-badge-${status}`} className={cn(ORDER_CLS[status] || ORDER_CLS.ny, className)}>{STATUS[status] || status}</Pill>;
export const InquiryStatus = ({ status, className, size }) => <Pill size={size} testid={`inquiry-status-badge-${status}`} className={cn(INQ_CLS[status] || INQ_CLS.ny, className)}>{INQ_STATUS[status] || status}</Pill>;
export const Priority = ({ priority, className, hideNormal = false, size = "sm" }) => {
  if (!priority || (hideNormal && (priority === "normal" || priority === "lav"))) return null;
  return <Pill size={size} testid={`priority-badge-${priority}`} className={cn(PRIO_CLS[priority] || PRIO_CLS.normal, className)}>{PRIORITY[priority] || priority}</Pill>;
};
export const QuoteStatus = ({ status, className, size }) => <Pill size={size} testid={`quote-status-badge-${status}`} className={cn(QUOTE_CLS[status] || QUOTE_CLS.utkast, className)}>{QUOTE_STATUS[status] || status}</Pill>;
export const DocStatus = ({ status, className, size }) => {
  if (!status) return <Pill size={size} className={cn("tone-quiet", className)}>Ikkje kontrollert</Pill>;
  return <Pill size={size} testid={`doc-status-badge-${status}`} className={cn(DOC_CLS[status] || DOC_CLS.boer_sjekkast, className)}>{DOC_STATUS[status] || status}</Pill>;
};
/* Plain tag without a dot, e.g. market or order type. */
export const Chip = ({ children, className }) => <span className={cn("inline-flex h-6 items-center whitespace-nowrap rounded-md bg-secondary px-2 text-[12px] font-medium text-foreground/85", className)}>{children}</span>;
